<template>
  <div>
    <div class="ibox">
      <div class="ibox-title">
        <h5>Generate URL</h5>
      </div>
      <div class="ibox-content ibox-heading">
        Generate url feeds from on air panel or campaigns
      </div>

      <div class="ibox-content">
        <el-form ref="form" label-width="158px">

          <el-form-item label="Generate For">
            <el-radio-group v-model="isGenerateForOnAir" size="medium">
              <el-radio border :label="true">On Air</el-radio>
              <el-radio border :label="false">Campaign</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item v-if="!isGenerateForOnAir" label="Available Campaigns">
            <el-select v-model="selectedId" placeholder="Select" filterable>
              <el-option
                v-for="campaign in activeCampaigns"
                :key="campaign.id"
                :label="campaign.title"
                :value="campaign.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="isGenerateForOnAir" label="Available Users">
            <el-select v-model="selectedId" placeholder="Select" filterable>
              <el-option
                v-for="user in companyUsers"
                :key="user.id"
                :label="user.display_name"
                :value="user.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Response Type">
            <el-radio-group v-model="isResponseTypeRSS" size="medium">
              <el-radio border :label="true">RSS</el-radio>
              <el-radio border :label="false">JSON</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item v-if="generateUrlSuccess" label="Generated Url">
            <el-input v-model="generatedUrl" readonly></el-input>
          </el-form-item>

          <el-form-item>
            <el-button :loading="loadingGenerateUrl" :disabled="selectedId === null" type="primary" @click="generate" plain>Generate</el-button>
          </el-form-item>

        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GenerateURL',
  data: () => ({
    isGenerateForOnAir: true,
    isResponseTypeRSS: true,
    selectedId: null,
  }),
  props: {
    companyUsers: {
      type: Array,
      default: () => [],
      required: true,
    },
    activeCampaigns: {
      type: Array,
      default: () => [],
      required: true,
    },
    generatedUrl: {
      type: String,
      default: '',
      required: false,
    },
    loadingGenerateUrl: {
      type: Boolean,
      required: false,
      default: false,
    },
    generateUrlSuccess: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    generate() {
      const payLoad = {
        selectedId: this.selectedId,
        isResponseTypeRSS: this.isResponseTypeRSS,
        isGenerateForOnAir: this.isGenerateForOnAir,
      };

      this.$store.dispatch('publishing/requestGenerateUrl', payLoad);
    },
  },
};
</script>


// WEBPACK FOOTER //
// GenerateURL.vue?b555f114